/* this file is automatically generated.  edit at your own peril */
/* copyright 2015 Minted LLC.  All rights reserved */
var module; UMD(module, {
  'minted:m': ['M'],
  'minted:template': [],
  'minted:vendor/underscore-1.8.2.min': '_',
})(this, function (m_module, m_template, _) {
var M = m_module.M;

M.Template || (M.Template = {});
M.Template.DesignerStorefront || (M.Template.DesignerStorefront = {});

M.Template.DesignerStorefront.Fan = M.templateWrapper(function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='';

// Copyright (C) 2014 Minted Inc.
// All Rights Reserved

// TODO: Remove hard-coding of image paths. This was done to
// get around what appeared to be an issue with sprite compilation

__p+='\n<div class="pill storefrontFan">\n  ';
 if (isFan) { 
__p+='\n    <div class="pillLabel pillLabelRounded floatL inactive">\n      <img class="sprite fanIconActive"\n        src="'+
((__t=( M.img_src('/static/images/sprite_placeholder.png') ))==null?'':__t)+
'"/>\n    </div>\n  ';
 } else { 
__p+='\n    <div class="pillLabel pillLabelRounded floatL">\n      <img class="sprite fanIconInactive"\n        src="'+
((__t=( M.img_src('/static/images/sprite_placeholder.png') ))==null?'':__t)+
'"/>\n    </div>\n  ';
 } 
__p+='\n  <div class="pillPointerWrap floatR">\n    <div class="pillPointerArrowLeft"></div>\n    <span class="pillPointer">\n      <span class="fanCount">'+
((__t=( M.html.htmlEscape(fanCount) ))==null?'':__t)+
'</span>\n      <span class="fanDescriptor"> FANS</span>\n    </span>\n  </div>\n</div>\n';
}
return __p;
});

M.Template.DesignerStorefront.Popover = M.templateWrapper(function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='';

// Copyright (C) 2014 Minted Inc.
// All Rights Reserved

__p+='\n<iframe class="storefront-iframe" src="'+
((__t=( M.html.htmlEscape(src) ))==null?'':__t)+
'"></iframe>\n<div class="loading"><div class="loading-message">loading...</div></div>\n';
}
return __p;
});

M.Template.DesignerStorefront.PreviewBar = M.templateWrapper(function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='';

// Copyright (C) 2015 Minted Inc.
// All Rights Reserved
// CTAG:COMMUNITY:STORES

__p+='\n<div id="statusContainer" class="floatL">\n  <span>\n    <img class="sprite checkmarkGreen16 '+
((__t=( M.html.htmlAttributeEscape(spriteClass) ))==null?'':__t)+
'"\n    src="'+
((__t=( M.img_src("/static/images/sprite_placeholder.png") ))==null?'':__t)+
'"/>\n  </span>\n  <span class="previewMode upper '+
((__t=( M.html.htmlAttributeEscape(statusExtraClass) ))==null?'':__t)+
'">\n    '+
((__t=( M.html.htmlAttributeEscape(statusText) ))==null?'':__t)+
'\n  </span>\n</div>\n<div class="floatR buttonGroup">\n  <div id="secondaryButtonContainer" class="floatR buttonContainer"></div>\n  <div id="makeChangesButtonContainer" class="floatR buttonContainer"></div>\n</div>\n';
}
return __p;
});


return {};

});
/* end templito generated file */
